import { TextMS, TextRXS, TextSS } from "../../common/text";
import {
  Container,
  DataSet,
  Header,
  Image,
  TextBox,
} from "./TicketCard.styles";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";
import { convertFromDbDateToSimpleDate } from "./../../helpers";

const TicketCard = ({ ticket }) => {
  const navigate = useNavigate();

  const goToTicketDetail = (pk) => {
    navigate("/my-tickets/" + pk, { state: { ticket } });
  };

  return (
    <Container onClick={() => goToTicketDetail(ticket?.pk)}>
      <Header>
        <TextMS>{ticket?.product?.name}</TextMS>
      </Header>
      <Image
        src={ticket?.product?.images[0]}
        loading="lazy"
        decoding="async"
      ></Image>
      <TextBox>
        <DataSet>
          <TextSS>권종</TextSS>
          <TextRXS>{ticket?.product?.div}</TextRXS>
        </DataSet>

        {ticket?.usedDate && (
          <DataSet>
            <TextSS>이용기간</TextSS>
            <TextRXS>{ticket.validDate}</TextRXS>
          </DataSet>
        )}

        {!ticket?.usedDate && ticket?.isValidTicket && (
          <DataSet>
            <TextSS>이용기간</TextSS>
            <TextRXS>{ticket.validDate}</TextRXS>
          </DataSet>
        )}
        {!ticket?.usedDate && !ticket?.isValidTicket && (
          <Chip
            label={<TextSS color="white">{ticket.validDate}</TextSS>}
            style={{
              backgroundColor: "#ED1B23",
              width: "150px",
              marginTop: "10px",
            }}
          ></Chip>
        )}

        {!ticket?.isRefundPossible && (
          <Chip
            label={<TextSS color="white">{"취소 불가 상품"}</TextSS>}
            style={{ backgroundColor: "#ED1B23", width: "150px" }}
          ></Chip>
        )}

        {!ticket?.cancelDate && ticket?.cancelRequestDate && (
          <Chip
            label={
              <TextSS color="#333333">
                {ticket?.refundDate
                  ? ticket?.refundAmount !== 0
                    ? `${convertFromDbDateToSimpleDate(
                        ticket?.refundDate
                      )} 에 ${ticket?.refundAmount.toLocaleString(
                        "ko-KR"
                      )}원 환불 예정`
                    : `${convertFromDbDateToSimpleDate(
                        ticket?.refundDate
                      )} 에 환불 예정`
                  : "취소중"}
              </TextSS>
            }
            style={{
              backgroundColor: "#B2D8D8",

              maxWidth: "300px",
            }}
          ></Chip>
        )}
      </TextBox>
    </Container>
  );
};

export default TicketCard;
